exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bubble {\n  margin: 5px;\n  padding: 15px;\n  font-size: 1.5rem;\n}\n.bubble.info {\n    background-color: #77bbdd;\n    color: #f1f8fc;\n}\n.bubble.error {\n    background-color: #ff5555;\n    color: #ffeeee;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"1","vue":true,"scoped":false,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/components/bubble/bubble.scss
// module id = 148
// module chunks = 0